/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import {
  ArrowLeftOutlined,
  ExperimentOutlined,
  FilterOutlined,
  SearchOutlined,
  UsergroupAddOutlined,
} from '@ant-design/icons';
import {
  Badge,
  Button,
  Card,
  Col,
  Collapse,
  Form,
  Input,
  message,
  Modal,
  Row,
  Space,
  Spin,
  Typography,
} from 'antd';
import { getAreas, getTiposDeEmpleados } from 'api/catalogos';
import { getCategorias, getPlazas } from 'api/catalogos/plazas';
import Table from 'components/Table';
import { getPuestos } from 'api/catalogos/puestos';
import { getVacantes } from 'api/catalogos/Vacantes';
import { getEmpleadosOptimized } from 'api/estructuraOrganizacional/empleados';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { checkToken } from 'api/utils';
import React, { useEffect, useState } from 'react';
import { ESTATUS_AUTORIZADO } from 'utils/constants';
import { getSolicitudDeContratacionvistaOptimized } from 'api/reclutamiento/SolicitudesDeContratacion';
import FormSubmitControls from 'components/FormSubmitControls';
import { getCandidatovistaOptimized, putAutorizarContratacion } from 'api/catalogos/Candidatos';
import CandidatosPorVacante from './CandidatosPorVacante';
import FichaCandidatoView from './FichaCandidatoView';
import PruebasPage from '../Pruebas/Pruebas';

const { Title, Text } = Typography;
const { Panel } = Collapse;

const ContratacionCandidatos = ({
  permission,
  estadoBusqueda,
  estadoCandidato,
  psicometrico,
  contratacion_estados_globales,
}) => {
  const [form] = Form.useForm();
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [puestos, setPuestos] = useState([]);
  const [areas, setAreas] = useState([]);
  const [tiposEmpleados, setTiposEmpleados] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [tiposDeAsignacion, setTiposDeAsignacion] = useState([]);
  const [tiposNominasEmpleados, setTiposNominasEmpleados] = useState([]);
  const [data, setData] = useState([]);
  const [empleado, setEmpleado] = useState([]);
  const [plazas, setplazas] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isModalPruebas, setIsModalPruebas] = useState(false);
  const [selectedVacante, setSelectedVacante] = useState(null); // para candidatos
  const [selectedVacantePruebas, setSelectedVacantePruebas] = useState(null); // para pruebas
  const [selectedData, setSelectedData] = useState({});
  const [confirmAutorizarOpen, setConfirmAutorizarOpen] = useState(false);
  const [fichaOpen, setFichaOpen] = useState(false);
  const [fichaCandidatoId, setFichaCandidatoId] = useState(null);

  const identifcadoresCandidato = {
    title: 'Candidato',
    name: 'candidato_numero_y_nombre_completo',
  };
  const identifcadoresArea = {
    title: 'Área Vacante',
    name: 'vacante_directorio_de_area_clave_y_nombre',
  };
  const identifcadoresPuesto = {
    title: 'Puesto Vacante',
    name: 'vacante_puesto_clave_y_descripcion',
  };
  const identifcadoresPlaza = {
    title: 'Plaza Vacante',
    name: 'vacante_plaza_clave_y_descripcion',
  };
  const identifcadoresTipoEmpleado = {
    title: 'Tipo de Empleado',
    name: 'vacante_tipo_de_empleado_descripcion',
  };

  const normalizeDataAreas = (_areasFetchArray) => {
    const mainMap = new Map();
    _areasFetchArray.forEach((item) => {
      mainMap.set(item.id, { ...item, children: [] });
    });

    const result = [];

    _areasFetchArray.forEach((item) => {
      if (item.directorio_area_padre) {
        const parent = mainMap.get(item.directorio_area_padre);
        if (parent) {
          parent.children.push(mainMap.get(item.id));
        }
      } else {
        result.push(mainMap.get(item.id));
      }
    });

    const sortByClave = (nodes) => {
      nodes.sort((a, b) => a.clave.localeCompare(b.clave));
      nodes.forEach((node) => {
        if (node.children && node.children.length > 0) {
          sortByClave(node.children);
        }
      });
    };

    sortByClave(result);

    return result;
  };
  // Esta función adapta el árbol para que funcione con TreeSelect
  const formatTreeSelectData = (nodes) => nodes.map((node) => ({
    title: `${node.clave} - ${(node.nombre || 'Sin nombre').trim()}`,
    value: node.id,
    children: node.children ? formatTreeSelectData(node.children) : [],
  }));

  function mapVacanteData(
    apiData = { results: [] },
    empleadosData = [],
    puestosData = [],
    plazasData = [],
    areasData = [],
    tiposEmpleadoData = [],
  ) {
    if (!apiData?.results?.map) return [];

    return apiData.results.map((item) => {
      const empleadoEncontrado = empleadosData.find((e) => e.id === item.empleado);
      const puestoSolicitante = puestosData.find((p) => p.id === item.puesto);
      const puestoPlaza = puestosData.find((p) => p.id === item.puesto_plaza);
      const plaza = plazasData.results.find((pl) => pl.id === item.plaza);
      const areaSolicitante = areasData.find((a) => a.id === item.directorio_de_area_adscripcion);
      const areaPlaza = areasData.find((a) => a.id === item.directorio_de_area_adscripcion_plaza);
      const tipoEmpleado = tiposEmpleadoData.find((te) => te.id === item.tipo_empleado);

      return {
        id: item.id,

        // Solicitud
        solicitudFolio: item.folio ? `SOL-${item.folio}` : 'Folio no disponible',
        solicitudFecha: item.fecha_de_solicitud
          ? new Date(item.fecha_de_solicitud).toLocaleDateString('es-MX', { day: 'numeric', month: 'numeric', year: 'numeric' })
          : 'Fecha no disponible',
        numeroOficio: item.no_de_oficio || 'Sin número',

        // Solicitante
        solicitanteId: empleadoEncontrado?.id || 'Desconocido',
        solicitanteNombre: `${empleadoEncontrado?.nombre || ''} ${empleadoEncontrado?.apellido_paterno || ''} ${empleadoEncontrado?.apellido_materno || ''}`.trim() || 'Desconocido',
        solicitanteAreaCodigo: areaSolicitante?.clave || 'N/A',
        solicitanteAreaNombre: areaSolicitante?.nombre || 'Área no encontrada',
        solicitantePuesto: puestoSolicitante?.descripcion || 'Sin puesto',
        solicitantePlaza: plaza?.clave || 'Sin plaza asignada',

        // Vacante
        vacanteAreaCodigo: areaPlaza?.clave || 'N/A',
        vacanteAreaNombre: areaPlaza?.nombre || 'Área no encontrada',
        vacantePlaza: plaza?.clave || 'Sin plaza asignada',
        vacantePuesto: puestoPlaza?.descripcion || 'Sin puesto',
        vacanteCodigo: puestoPlaza?.descripcion || `PLZ-${item.plaza ?? 'Desconocida'}`,
        vacanteEstatus: item.estados_globales === 1 ? 'Activa' : 'Inactiva',
        vacanteMotivo: item.motivo || 'Motivo no especificado',

        // Tipo de Empleado
        empleadoTipo: tipoEmpleado?.descripcion || 'Tipo no definido',

        // Otros
        candidatosTotal: Math.floor(Math.random() * 10), // valor temporal
        pruebasAsignadas: item.pruebas_asignadas || ['Técnica Frontend', 'Psicométrica General'], // ejemplo
      };
    });
  }

  // useEffect(() => {
  //   if (Array.isArray(data) && data.length > 0) {
  //     const ordenadas = [...data].sort((a, b) => a.vacante_id - b.vacante_id);
  //     setData(withId(ordenadas)); // <-- importante
  //   } else {
  //     setData([]);
  //   }
  // }, [data]);
  const parametroSearch = 'candidato.estados_globales_id';
  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        // _empleado,
        // _tiposEmpleados,
        // _categorias,
        // _puestos,
        // _areas,
        // _tiposNominasEmpleados,
        // _plazas,
        _data,
      ] = await Promise.all([
        // getEmpleadosOptimized(),
        // getTiposDeEmpleados(),
        // getCategorias(),
        // getPuestos({ estados_globales: ESTATUS_AUTORIZADO }),
        // getAreas(),
        // getTiposDeNominasEmpleados(),
        // getPlazas(),
        getCandidatovistaOptimized({
          ...(estadoBusqueda != null && {
            estados_globales_id: estadoBusqueda,
          }),
          ...(psicometrico != null && {
            resultados_psicometrico_id: psicometrico,
          }),
          ...(contratacion_estados_globales != null && {
            contratacion_estados_globales_id: contratacion_estados_globales,
          }),
          ...(estadoCandidato != null && {
            candidato_estado_del_candidato_id: estadoCandidato,
          }),
        }),
      ]);
      // const formattedURS = normalizeDataAreas(_areas);
      // const formattedTreeData = formatTreeSelectData(formattedURS);
      // const formatData = inflateData(_data, _puestos);
      if (mounted) {
        // setEmpleado(_empleado);
        // setTiposNominasEmpleados(_tiposNominasEmpleados);
        // setplazas(_plazas);
        // setTiposEmpleados(_tiposEmpleados);
        // setCategorias(_categorias);
        // setPuestos(_puestos);
        // setAreas(_areas);
        setData(_data.sort((a, b) => a.vacante_id - b.vacante_id));
        setLoading(false);
      }
      setLoading(false);
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const columns = [
    {
      // titleText: 'Datos de la Vacante',
      // align: 'center',
      // children: [
      // {
      titleText: identifcadoresCandidato.title,
      dataIndex: identifcadoresCandidato.name,
      key: identifcadoresCandidato.name,
      width: 250,
      render: (val) => val ?? '—',
    },
    {
      titleText: identifcadoresArea.title,
      dataIndex: identifcadoresArea.name,
      key: identifcadoresArea.name,
      width: 250,
      render: (val) => val ?? '—',
    },
    {
      titleText: identifcadoresPuesto.title,
      dataIndex: identifcadoresPuesto.name,
      key: identifcadoresPuesto.name,
      width: 200,
      render: (val) => val ?? '—',
    },
    {
      titleText: identifcadoresPlaza.title,
      dataIndex: identifcadoresPlaza.name,
      key: identifcadoresPlaza.name,
      width: 250,
      render: (val) => val ?? '—',
    },
    {
      titleText: identifcadoresTipoEmpleado.title,
      dataIndex: identifcadoresTipoEmpleado.name,
      key: identifcadoresTipoEmpleado.name,
      width: 200,
      render: (val) => val ?? '—',
    },
    // ],
    // },
  ];

  // useEffect(() => {
  //   if (selectedVacantePruebas?.vacante_id) {
  //   }
  // }, [selectedVacantePruebas]);

  const getBadgeStatus = (estado) => {
    switch (estado) {
      case 'Activa':
        return 'default';
      case 'Autorizada':
      case 'Cita para Entrevista':
        return 'processing';
      case 'Cancelada':
        return 'error';
      case 'En Reclutamiento':
      case 'En Evaluación':
        return 'warning';
      case 'Seleccionado(a)':
      case 'Contratado(a)':
        return 'success';
      default:
        return 'default';
    }
  };

  const vacantes = mapVacanteData(data, empleado, puestos, plazas, areas, tiposEmpleados);
  const vacantesFiltradas = vacantes.filter((v) => v.vacantePlaza?.toLowerCase().includes(searchTerm.toLowerCase()));

  if (selectedVacante) {
    return (
      <div style={{ padding: 10 }}>
        <Button
          type="link"
          icon={<ArrowLeftOutlined />}
          onClick={() => setSelectedVacante(null)}
          style={{ marginBottom: 30 }}
        >
          Volver a Vacantes
        </Button>
        <CandidatosPorVacante vacante={selectedVacante} />
      </div>
    );
  }
  // Función para manejar el clic en una fila de la tabla

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });
    form.setFieldsValue(record);
  };

  // Abre la Ficha del Candidato (solo lectura). Recibe el registro desde el
  // doble clic; si no llega (p. ej. botón "Vista completa"), usa el seleccionado.
  const abrirFichaCandidato = (record) => {
    const target = record && record.id ? record : selectedData;
    if (!target || !target.id) {
      message.warning('Selecciona un candidato primero.');
      return;
    }
    setFichaCandidatoId(target.id);
    setFichaOpen(true);
  };

  // Función para manejar el tipo de selección de filas
  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {/* Botonera superior */}
        {/* <Row justify="end" gutter={8} style={{ marginBottom: 12 }}>
        <Col>
          <Button
            onClick={onClickGestionarCandidatos}
            disabled={!selectedRowKeys.length}
            icon={<UsergroupAddOutlined />}
            type="primary"
          >
            Gestionar Candidatos
          </Button>
        </Col>
        <Col>
          <Button
            onClick={onClickPruebas}
            disabled={!selectedRowKeys.length}
            icon={<ExperimentOutlined />}
          >
            Pruebas
          </Button>
        </Col>
      </Row> */}
        <Table
          rowKey="vacante_id"
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          permission={permission}
          allowExportPDF={false}
          pagination
          allowDoubleClick
          controls={{
            // Doble clic (o "Vista completa") abre la Ficha del Candidato.
            onClickExpand: (record) => abrirFichaCandidato(record),
          }}
        />

        <FichaCandidatoView
          open={fichaOpen}
          onClose={() => {
            setFichaOpen(false);
            setFichaCandidatoId(null);
          }}
          candidatoId={fichaCandidatoId}
        />

      </Spin>
    </Row>

  );
};

export default ContratacionCandidatos;
